import styled, { css } from 'styled-components';

import { MAX_WIDTH_PAGE, HORIZONTAL_PADDING_PAGE_DEFAULT } from '../../styles'
import { dashboardTheme } from '../../pages/OwnerDashboard/theme/dashboardTheme';

interface IHeader {
	hasBorder?: boolean;
	isToShowSearchBarMobile?: boolean;
	hasSearchBar?: boolean;
	hideLogoMobile?: boolean;
	$isDark?: boolean;
}

interface ILinkAndSearchContainer {
	isToDisapear?: boolean;
	hideLogoMobile?: boolean;
}

interface ILogoImage {
	hideLogoMobile?: boolean;
}

export const Container = styled.div<IHeader>`
	${({ $isDark }) =>
		$isDark &&
		css`
			background: ${dashboardTheme.colors.background};
		`}
`;

export const LogoIconMobile = styled.div<IHeader>`
	display: none;

	@media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
		display: flex;
		align-items: center;
		margin-left: auto;

		a {
			display: flex;
			align-items: center;
		}

		img {
			width: 28px;
			height: 28px;
			object-fit: contain;
		}
	}
`;

export const Header = styled.header<IHeader>`
	padding: 24px 0px;
	background: ${({ $isDark }) => ($isDark ? dashboardTheme.colors.background : "transparent")};

	${props => !!props.hasBorder && css`
		border-bottom: 1px solid ${props.$isDark ? dashboardTheme.colors.cardBorder : props.theme.palette.greyscale.grey50};
	`}
`;

export const HeaderContent = styled.header`
	max-width: ${MAX_WIDTH_PAGE};
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-left: ${HORIZONTAL_PADDING_PAGE_DEFAULT.SM};
	padding-right: ${HORIZONTAL_PADDING_PAGE_DEFAULT.SM};

    @media(min-width: ${({ theme }) => theme.breakpoints.tablet}){
        padding-left: ${HORIZONTAL_PADDING_PAGE_DEFAULT.MD};
        padding-right: ${HORIZONTAL_PADDING_PAGE_DEFAULT.MD};
    }

	@media(min-width: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) => theme.breakpoints.tabletLg}){
		padding-left: 24px;
		padding-right: 24px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}){
		padding-left: 24px;
		padding-right: 24px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}){
		padding-left: 28px;
		padding-right: 28px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}) and (max-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
		padding-left: 32px;
		padding-right: 32px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
		padding-left: 40px;
		padding-right: 40px;
	}
`;

export const LogoImage = styled.img<ILogoImage>`
  width: 100px;
  height: auto;
  
  @media(min-width: ${({ theme }) => theme.breakpoints.tablet}){
    width: auto;
    max-height: 40px;
  }

	@media(min-width: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) => theme.breakpoints.tabletLg}){
		max-height: 34px;
	}

  ${props => props.hideLogoMobile && css`
    @media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
      display: none !important;
    }
  `}
`;

export const LogoAndButtonContainer = styled.div<IHeader>`
	display: flex;
	align-items: center;
	justify-content: center;

	@media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}){
		margin-right: 12px;
	}

	a {
		padding-left: 18px;
		display: flex;
		align-items: center;
		
		${props => !!props.isToShowSearchBarMobile && css`
			padding-left: 8px;
		` }
		
		${props => props.hideLogoMobile && css`
			@media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
				padding-left: 0 !important;
				display: none !important;
			}
			
			@media(min-width: ${({ theme }) => theme.breakpoints.tablet}){
				padding-left: 18px;
				display: flex !important;
			}
		`}
	}

	button {
		display: flex;
		align-items: center;
		justify-content: center;
		background: transparent;
		border: 0;
		
		${props => props.hideLogoMobile && css`
			@media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
				margin-right: 12px !important;
			}
		`}
		
		${props => !!props.isToShowSearchBarMobile && props.hideLogoMobile && css`
			margin-left: -2px;
			margin-right: 4px;
		`}
	}	

	@media(min-width: ${({ theme }) => theme.breakpoints.tablet}){
		button {
			display: none;
		}

		a {
			padding-left: 0;
		}
	}

	@media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
		width: ${props => !props.hideLogoMobile ? '100%' : 'auto'};
		justify-content: ${props => !props.hideLogoMobile ? 'space-between' : 'flex-start'};

		a {
			padding-left: 0;
		}

		button {
			margin-left: ${props => props.hideLogoMobile ? 'auto' : '0'};
			${props => !props.hideLogoMobile && css`
				margin-right: 0 !important;
			`}
		}
	}
`;

export const LinkAndSearchContainer = styled.div<ILinkAndSearchContainer>`
	display: flex;
	align-items: center;
	justify-content: center;

	@media(min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}){
		flex: 1;
		min-width: 0;
		justify-content: flex-start;
		gap: 10px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}){
		flex: 1;
		min-width: 0;
		justify-content: flex-start;
		gap: 12px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}){
		flex: 1;
		min-width: 0;
	}

	>button{
		display: none;
	}

	@media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
		width: 100%;
		position: relative;

		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		${LogoAndButtonContainer} {
			flex-shrink: 0;
			${props => props.hideLogoMobile && css`
				order: 3;
				min-width: auto !important;
			`}
			
			${props => !props.hideLogoMobile && css`
				min-width: auto;
			`}
		}

		>button{
			display: ${props => !!props.isToDisapear ? 'none' : 'flex'};
			${props => props.hideLogoMobile && css`
				order: 2;
			`}

			/* Keep the trigger perfectly centered regardless of side content widths */
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			margin: 0;
		}

		/* Centralizar a barra de pesquisa */
		> form {
			flex: 1;
			min-width: 0;
			margin: 0 auto;
			${props => props.hideLogoMobile && css`
				order: 2;
			`}
		}

		/* Ajuste do ícone da logo para ficar ao lado direito do ícone de busca */
		${'' /* LogoIconMobile is a sibling after the search button; give small gap */}
		> div.logo-mobile {
			display: flex;
			align-items: center;
			margin-left: auto;
			flex-shrink: 0;

			${props => props.hideLogoMobile && css`
				order: 1;
				margin-left: 0;
				margin-right: 8px;
			`}
		}
	}
`;

export const Options = styled.nav<IHeader>`
	margin-left: 100px;

	@media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
		display: none;
		margin-left: 0;
	}

	${props => !!props.hasSearchBar && css`
		margin-left: 40px;

		@media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}){
			margin-left: auto;
		}

		@media(min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}){
			margin-left: auto;
			margin-right: 10px;
		}

		@media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}) and (max-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
			margin-left: auto;
			margin-right: 12px;
		}

		@media(min-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
			margin-left: auto;
			margin-right: 16px;
		}
	`}
	
	${props => props.hideLogoMobile && css`
		@media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
			margin-left: 0 !important;
			display: none !important;
		}
	`}
`;

export const OptionsItemsContainer = styled.div<IHeader>`
	display: none;
	align-items: center;
	justify-content: center;
	gap: 30px;

	@media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}){
		gap: 14px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}){
		gap: 12px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}) and (max-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
		gap: 16px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
		gap: 20px;
	}
	
	a {
		font-family: Montserrat;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 17px;
		letter-spacing: 0em;
		text-align: left;
		text-decoration: none;
		color: ${({ $isDark, theme }) =>
			$isDark ? dashboardTheme.colors.textSecondary : theme.palette.greyscale.grey500};
		transition: color 0.2s ease;

		&:hover {
			color: ${({ $isDark, theme }) =>
				$isDark ? dashboardTheme.colors.textPrimary : theme.palette.greyscale.grey700};
		}
	}

    @media(min-width: ${({ theme }) => theme.breakpoints.tablet}){
        display: none;
    }

    @media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}){
		display: flex;
    }
`;

export const ButtonLogin = styled.div<IHeader>`
	align-items: center;
	justify-content: center;
	display: none;

	a#button-link {
		min-width: 130px;
		height: 50px;
		line-height: 50px;
		border-radius: 45px;
		padding: 0px 20px;
		border: 2px solid ${({ theme }) => theme.palette.primary.blue600};
		background: transparent;
		color: ${({ theme }) => theme.palette.primary.blue600};
		text-align: center;
		font-family: Montserrat;
		font-size: 14px;
		font-style: normal;
		font-weight: 700;
		letter-spacing: 0em;

		@media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}){
			min-width: 116px;
			padding: 0px 14px;
		}

		@media(min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}){
			min-width: 118px;
			padding: 0px 14px;
		}

		@media(min-width: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) => theme.breakpoints.tabletLg}){
			min-width: 108px;
			height: 44px;
			line-height: 44px;
			padding: 0px 12px;
		}
	}

	>p {
		margin-left: 16px;
		font-size: 14px;
		font-weight: bold;
		color: ${({ $isDark, theme }) =>
			$isDark ? dashboardTheme.colors.textPrimary : theme.palette.primary.blue500};
	}

	>button {
		display: flex;
		align-items: center;
		justify-content: center;
		background: transparent;
		border: 0;
		margin-left: 18px;
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) => theme.breakpoints.tabletLg}){
		>button {
			margin-left: 10px;
		}
	}

    @media(min-width: ${({ theme }) => theme.breakpoints.tablet}){
		display: flex;

		>p {
			font-size: 16px;
		}
    }

	@media(min-width: ${({ theme }) => theme.breakpoints.tabletLg}) and (max-width: ${({ theme }) => theme.breakpoints.desktop}){
		margin-left: 12px;

		>button {
			margin-left: 12px;
		}
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktop}) and (max-width: ${({ theme }) => theme.breakpoints.desktopXl}){
		margin-left: 12px;

		>button {
			margin-left: 10px;
		}
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}) and (max-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
		margin-left: 14px;

		>button {
			margin-left: 12px;
		}
	}

	@media(min-width: ${({ theme }) => theme.breakpoints.desktopTxl}){
		margin-left: 16px;

		>button {
			margin-left: 14px;
		}
	}
`;

export const SearchIconButton = styled.button<IHeader>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	background: ${({ $isDark }) =>
		$isDark ? dashboardTheme.colors.backgroundAlt : "#ffffff"};
	border: 1px solid
		${({ $isDark, theme }) =>
			$isDark ? dashboardTheme.colors.cardBorder : theme.palette.greyscale.grey100};
	border-radius: 999px;
	cursor: pointer;
	padding: 5px 10px;
	margin-right: 10px;
	transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
	font-family: 'Montserrat', sans-serif;
	font-size: 11px;
	font-weight: 600;
	color: ${({ $isDark, theme }) =>
		$isDark ? dashboardTheme.colors.textSecondary : theme.palette.greyscale.grey500};
	box-shadow: ${({ $isDark }) =>
		$isDark ? "none" : "0 2px 8px rgba(17, 24, 39, 0.08)"};
	white-space: nowrap;
	flex-shrink: 0;

	/* Ocultar em mobilexs (475px+) e acima */
	@media (min-width: ${({ theme }) => theme.breakpoints.mobileXs}) {
		display: none !important;
	}

	&:hover {
		background: ${({ $isDark, theme }) =>
			$isDark ? dashboardTheme.colors.accentSoft : theme.palette.primary.blue50};
		border-color: ${({ $isDark, theme }) =>
			$isDark ? dashboardTheme.colors.accentBorder : theme.palette.greyscale.grey100};
		box-shadow: ${({ $isDark }) =>
			$isDark ? "none" : "0 4px 12px rgba(17, 24, 39, 0.12)"};
		transform: translateY(-1px);
	}

	&:focus,
	&:focus-visible {
		outline: none;
		border-color: ${({ theme }) => theme.palette.greyscale.grey100};
	}

	&:active {
		transform: translateY(0);
		box-shadow: 0 1px 4px rgba(17, 24, 39, 0.08);
	}

	svg {
		width: 12px;
		height: 12px;
		padding: 4px;
		box-sizing: content-box;
		border-radius: 50%;
		background: ${({ theme }) => theme.palette.primary.blue500};
		border: 0;
		flex-shrink: 0;
		transition: transform 0.2s ease;
		color: #ffffff;
	}

	&:hover svg {
		transform: scale(1.04);
	}

	span {
		white-space: nowrap;
		letter-spacing: 0.1px;
		color: ${({ $isDark, theme }) =>
			$isDark ? dashboardTheme.colors.textSecondary : theme.palette.greyscale.grey500};
	}
`;